export function sanitiseInput(sanitisedInput) {
    return (url) => {
        let tempUrl = url;
        if (url) {
            sanitisedInput.forEach((sanitise) => {
                tempUrl = tempUrl.replace(sanitise.match, sanitise.replacement);
            });
        }
        return tempUrl;
    };
}
//# sourceMappingURL=sanitise.js.map